<script setup>
import { usePlaylistStore } from "@/stores/playlist.js";
const plStore = usePlaylistStore();
import { ref, onMounted, watch } from 'vue'
import SingleActionModal from '@/Pages/Playlist/components/Misc/SingleActionModal.vue'

const props = defineProps({
    buttonText: {
        type: String,
        default: undefined,
    },
    modalTitle: {
        type: String,
        default: undefined,
    },
    modalBody: {
        type: String,
        default: undefined,
    },
    illustration: {
        type: String,
        default: undefined,
    },
    illustrationWidth: {
        type: String,
        default: undefined,
    },
    index: {
        type: Number,
        default: undefined,
    },
    brand: {
        type: Object,
        default: undefined,
    },
    headingFont: {
        type: String,
        default: '',
    },
    bodyFont: {
        type: String,
        default: '',
    },
})

const imgWidth = ref('100%');

// watch(
//     () => plStore.fontScale,
//     (newVal, prevVal) => {
//         const imgScale = (newVal * 0.75);
//         if (isNaN(imgScale) || imgScale >= 1) {
//             imgWidth.value = '100%'
//         }
//         const widthPercentage = Math.floor(imgScale * 100);
//         //imgWidth.value = `${widthPercentage}%`;
//         imgWidth.value = '100%'
//     }
// )

onMounted(() => {
    if (props.illustrationWidth !== undefined && props.illustrationWidth !== '') imgWidth.value = props.illustrationWidth + '%';
});

let modalOpen = ref(false);

function openModal() {
    modalOpen.value = true;
}

</script>

<template>
    <div>
        <button
            class="
                w-full 
                h-full 
                rounded-md 
                shadow-md 
                bg-white 
                px-fl-3 
                py-fl-2 
                text-sm 
                font-bold 
                focus-visible:outline-2 
                focus-visible:outline-offset-2 
                focus-visible:outline-platform-orange-dark
                flex
                flex-col
                items-center
                justify-between
                cursor-pointer
            "
            @click="openModal()"
        >
            <section class="grow py-fl-2 flex items-center">
                <img class="mx-auto object-contain" :style="'width: ' + imgWidth" :src="props.illustration" :alt="props.modalTitle">
            </section>
            <p class="mt-2">
                {{ props.buttonText }}
            </p>
        </button>
        <SingleActionModal
            v-model="modalOpen"
            :modal-title="modalTitle"
            :modal-body="modalBody"
            :brand="brand"
            :heading-font="headingFont"
            :body-font="bodyFont"
        />
    </div>
</template>

<style scoped>
button {
    border-color: var(--button_bg);
    background-color: var(--button_bg);
    color: var(--button_text);
}

button:hover {
    background-color: var(--button_hover_bg);
    color: var(--button_hover_text);
}
</style>
